const Index = () => import('./index.vue');
const CreatePage = () => import('./_pages/create.vue');
const ViewPage = () => import('./_pages/view.vue');

export default [
    {
        path: '/journal-entry',
        component: Index
    },
    {
        path: '/new-journal',
        component: CreatePage
    },
    {
        path: '/journal-entry/:id',
        component: ViewPage
    }
]